import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { CarRequestForm } from "@/components/CarRequestForm";

export const LeadForm = () => {
  return (
    <section id="reviews" data-testid="reviews-leadform-section" className="bg-[#F8F9FA] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-16">
        {/* Testimonials */}
        <div>
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#C8102E]">Reviews</p>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold tracking-tight uppercase text-[#0A0A0A] leading-[0.95]">
            Real people. <span className="text-[#C8102E]">Real experiences.</span>
          </h2>
          <div className="mt-10 space-y-6">
            {TESTIMONIALS.map((t, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                data-testid={`testimonial-${i}`}
                className="bg-white border border-gray-100 shadow-xl shadow-black/5 rounded-sm p-7"
              >
                <div className="flex gap-1 mb-3">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={18} className="fill-[#C8102E] text-[#C8102E]" />
                  ))}
                </div>
                <p className="text-[#0A0A0A] leading-relaxed">"{t.quote}"</p>
                <p className="mt-4 text-sm font-semibold text-gray-700">
                  {t.name} <span className="text-gray-400 font-normal">· {t.source}</span>
                </p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Lead Form */}
        <div id="contact" data-testid="lead-form-wrapper" className="scroll-mt-24">
          <div className="bg-white border border-gray-100 shadow-2xl shadow-black/10 rounded-sm p-8 lg:p-10">
            <CarRequestForm />
          </div>
        </div>
      </div>
    </section>
  );
};
